import { render, staticRenderFns } from "./CollectPayment.vue?vue&type=template&id=f7dacf60&scoped=true&"
import script from "./CollectPayment.vue?vue&type=script&lang=js&"
export * from "./CollectPayment.vue?vue&type=script&lang=js&"
import style0 from "./CollectPayment.vue?vue&type=style&index=0&id=f7dacf60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dacf60",
  null
  
)

export default component.exports